__turbopack_context__.v({
  "dot": "Switch-module__WmgdKa__dot",
  "spinner": "Switch-module__WmgdKa__spinner",
  "track": "Switch-module__WmgdKa__track",
});
